import { useMsal } from "@azure/msal-react";
import type { IPublicClientApplication } from "@azure/msal-browser";
import { useSyncExternalStore } from "react";
import { msalLoginRequest } from "../msal.config";
import { TokenBroker } from "./token-broker";

const brokers = new WeakMap<IPublicClientApplication, TokenBroker>();

// One broker per MSAL instance so the provider, interceptors and UI share in-flight requests and state.
export function getTokenBroker(instance: IPublicClientApplication) {
  let broker = brokers.get(instance);
  if (!broker) {
    broker = new TokenBroker(instance, {
      loginRequest: msalLoginRequest,
      silentRedirectUri: import.meta.env.VITE_AUTH_SILENT_REDIRECT_URI,
    });
    brokers.set(instance, broker);
  }
  return broker;
}

export function useTokenBroker() {
  const { instance } = useMsal();
  return getTokenBroker(instance);
}

export function useSessionState(broker: TokenBroker) {
  return useSyncExternalStore(broker.subscribe, broker.getState);
}
